module.exports = function UpdateSourceStateRequest(cid, old, current) {
    this.cid = cid;
    this.old = old;
    this.current = current;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-state-request.js
// module id = 488
// module chunks = 1